import { connect } from "react-redux";
import { setCurrentFlowAction } from "lib/redux/navigation";
import { RootDispatch, RootState } from "lib/redux/root/redux.types";
import { setSlotDetailsForCreateBundledLinkedAppointment } from "ui/appointment/ducks/appointmentsSlice";
import { AvailableBundledSlot } from "api/appointment/GetAvailableSlots/getAvailableSlots.toUi.types";
import { CREATE_APPOINTMENT_SLOT_MSG_KEY } from "api/shared/GetDocumentByType/getDocumentByType.mapper";
import { fetchDocumentForAllTypes } from "ui/appointment/ducks/thunks";
import CreateBundledLinkedApptAvailableSlotsPage from "./CreateBundledLinkedApptAvailableSlotsPage";
// ==========================
// MAP STATE TO PROPS
// ==========================

const mapStateToProps = (state: RootState) => {
  return {
    memberIdentifier: state.user.memberIdentifier,
    isSameDayBooking: state.appointments.appointmentMeta.isSameDayBooking,
    location: state.appointments.create?.selectedInstitution || "",
    service: state.appointments.create?.selectedService || "",
    lastVisitDatetime: state.appointments.create?.lastVisitDateTime,
    appointmentType: state.appointments.appointmentMeta.appointmentType,
    appointmentId: state.appointments.appointmentMeta.appointmentId,
    institutionCode: state.appointments.appointmentMeta.institutionCode,
    targetSystem: state.appointments.appointmentMeta.targetSystem,
    isLoadingSlotAndPreConsultMsg: state.appointments.documentByType.isLoading,
    slotMsg:
      state.appointments.documentByType.documentByTypeMap[
        CREATE_APPOINTMENT_SLOT_MSG_KEY
      ],
  };
};

// ==========================
// MAP DISPATCH TO PROPS
// ==========================
const mapDispatchToProps = (dispatch: RootDispatch) => {
  return {
    onLoad: () => {
      dispatch(setCurrentFlowAction("APPOINTMENT_CREATE"));
    },
    onSelect: (selectedBundledSlots: AvailableBundledSlot[]) => {
      const selectedBundledSlotsData = selectedBundledSlots.map((slot) => {
        return {
          datetime: slot.date,
          resource: slot.resource,
        };
      });

      dispatch(
        setSlotDetailsForCreateBundledLinkedAppointment([
          ...selectedBundledSlotsData,
        ]),
      );
    },
    fetchSlotAndPreConsultMsg: () => {
      dispatch(fetchDocumentForAllTypes());
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CreateBundledLinkedApptAvailableSlotsPage);
